import { z } from 'zod';
// Base Auth User DTO Schema (for authenticated users)
export const BaseAuthUserDTOSchema = z.object({
    id: z.uuid(), // BetterAuth generates v4 UUIDs via gen_random_uuid()
    name: z.string(),
    email: z.email(),
    emailVerified: z.boolean(),
    userType: z.enum(['customer', 'integrator', 'staff']),
    defaultCompanyId: z.uuid().nullable(),
    image: z.url().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
    isDeleted: z.boolean(),
});
// User Company DTO Schema
export const UserCompanyDTOSchema = z.object({
    id: z.uuidv7(),
    name: z.string(),
    slug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    logo: z.url().nullable(),
    role: z.enum(['owner', 'admin', 'member', 'viewer']),
    permissions: z.unknown(),
});
// Base Integrator DTO Schema
export const BaseIntegratorDTOSchema = z.object({
    id: BaseAuthUserDTOSchema.shape.id,
    name: BaseAuthUserDTOSchema.shape.name,
    email: BaseAuthUserDTOSchema.shape.email,
    emailVerified: BaseAuthUserDTOSchema.shape.emailVerified,
    defaultCompanyId: BaseAuthUserDTOSchema.shape.defaultCompanyId,
    companyName: z.string().nullable(),
    companySlug: z
        .string()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
        .nullable(),
    createdAt: BaseAuthUserDTOSchema.shape.createdAt,
    updatedAt: BaseAuthUserDTOSchema.shape.updatedAt,
});
// Integrator DTO Schema (extends base)
export const IntegratorDTOSchema = BaseIntegratorDTOSchema;
//# sourceMappingURL=auth.dto.js.map